import React from "react";
import { Box, Typography } from "@mui/material";
import { NJIM } from "../../theme/njimTheme";
import CodInitialsAvatar from "./CodInitialsAvatar";

interface ProfileChipProps {
  name: string;
  role: string;
}

const ProfileChip: React.FC<ProfileChipProps> = ({ name, role }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 1.25,
      px: 1.5,
      py: 1,
      borderRadius: "999px",
      border: `1px solid ${NJIM.border}`,
      background: NJIM.white,
      boxShadow: NJIM.elevation,
      minHeight: 44,
    }}
  >
    <CodInitialsAvatar name={name} size={32} />
    <Box sx={{ minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 700,
          color: NJIM.ink,
          lineHeight: 1.2,
          whiteSpace: "nowrap",
        }}
      >
        {name}
      </Typography>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 600,
          color: NJIM.textSecondary,
          lineHeight: 1.3,
        }}
      >
        {role}
      </Typography>
    </Box>
  </Box>
);

export default ProfileChip;
